import React from "react";

const Footer = () => {
  return (
    <footer className="bg-dark text-light pt-5 pb-4">
      <div className="container">
        <div className="row">

          {/* Brand Section */}
          <div className="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
            <h5 className="text-uppercase fw-bold mb-4">Oslolabs</h5>
            <p>
              We build scalable digital solutions with modern technologies.
              Clean UI, high performance, and production-ready systems.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
            <h6 className="text-uppercase fw-bold mb-4">Quick Links</h6>
            <p><a href="#" className="text-light text-decoration-none">Home</a></p>
            <p><a href="#" className="text-light text-decoration-none">About</a></p>
            <p><a href="#" className="text-light text-decoration-none">Services</a></p>
            <p><a href="#" className="text-light text-decoration-none">Contact</a></p>
          </div>

          {/* Services */}
          <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
            <h6 className="text-uppercase fw-bold mb-4">Services</h6>
            <p><a href="#" className="text-light text-decoration-none">Web Development</a></p>
            <p><a href="#" className="text-light text-decoration-none">UI/UX Design</a></p>
            <p><a href="#" className="text-light text-decoration-none">SEO Optimization</a></p>
            <p><a href="#" className="text-light text-decoration-none">Cloud Solutions</a></p>
          </div>

          {/* Contact */}
          <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
            <h6 className="text-uppercase fw-bold mb-4">Contact</h6>
            <p>📍 New Delhi, India</p>
            <p>📧 info@oslolabs.com</p>
            <p>📞 +91 98765 43210</p>
          </div>

        </div>

        <hr className="my-4" />

        {/* Bottom Section */}
        <div className="row align-items-center">
          <div className="col-md-7 col-lg-8 text-center text-md-start">
            <p className="mb-0">
              © {new Date().getFullYear()} Oslolabs. All rights reserved.
            </p>
          </div>

          <div className="col-md-5 col-lg-4 text-center text-md-end">
            <a href="#" className="text-light me-4">
              <i className="bi bi-facebook"></i>
            </a>
            <a href="#" className="text-light me-4">
              <i className="bi bi-twitter"></i>
            </a>
            <a href="#" className="text-light me-4">
              <i className="bi bi-linkedin"></i>
            </a>
            <a href="#" className="text-light">
              <i className="bi bi-github"></i>
            </a>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;